import React from 'react';

import { Chip, SxProps, Theme, Tooltip } from '@mui/material';

interface Props {
  sx?: SxProps<Theme>;
}

function LuxPlusMonthChip({ sx }: Props) {
  return (
    <Tooltip title="LuxPlus+ Month campaign offer">
      <Chip label="LP+ Month" size="small" color="info" sx={sx} />
    </Tooltip>
  );
}

export default LuxPlusMonthChip;
